import { AxiosPromise } from 'axios'
import {
  OrderGetDataBase,
  OrderUpdateStatePatchData,
  ProvisionGetDataBase
} from 'types/api/v1/order.type'

import OrbitApiV1 from '.'

class OrderAPI {
  static getAllOrders(
    limit = 1000,
    details = 1
  ): AxiosPromise<OrderGetDataBase[]> {
    return OrbitApiV1.httpGet(`/order?limit=${limit}&details=${details}`)
  }

  static getOrderStatus(orderNo: string): AxiosPromise<OrderGetDataBase> {
    return OrbitApiV1.httpGet(`/order/${orderNo}`)
  }

  static updateOrderState(
    orderNo: string,
    data: OrderUpdateStatePatchData
  ): AxiosPromise<Record<string, never>> {
    return OrbitApiV1.httpPut(`/order/${orderNo}/updateState`, {}, data)
  }

  static getProvisionedItemsForOrder(
    orderId
  ): AxiosPromise<ProvisionGetDataBase[]> {
    return OrbitApiV1.httpGet(`/order/${orderId}/provision`)
  }

  static getClientOrdersByOrgId(
    orgId: string,
    limit = 1000,
    details = 1
  ): AxiosPromise<OrderGetDataBase[]> {
    return OrbitApiV1.httpGet(
      `/order/clientOrders/${orgId}?limit=${limit}&details=${details}`
    )
  }

  static createOrder(orderDetails) {
    return OrbitApiV1.httpPost(`/order`, {}, orderDetails)
  }
}

export default OrderAPI
